const stockDomain = {
  data() {
    return {
      stockInventoryStatusEnum: {
        IN_PROGRESS: 'InProgress',
        INVOICE_PENDING: 'InvoicePending',
        COMPLETED_PENDING: 'CompletedPending',
        COMPLETED: 'Completed',
        CANCELED: 'Canceled',
      },
      stockCountingStatusEnum: {
        IN_PROGRESS: 'InProgress',
        COMPLETED: 'Completed',
        CANCELED: 'Canceled',
      },
      stockCountingDayOfWeekEnum: {
        SUNDAY: 'Sunday',
        MONDAY: 'Monday',
        TUESDAY: 'Tuesday',
        WEDNESDAY: 'Wednesday',
        THURSDAY: 'Thursday',
        FRIDAY: 'Friday',
        SATURDAY: 'Saturday',
      },
    }
  },

  computed: {
    stockReservationStatusEnum() {
      return {
        ACTIVE: 'Active',
        FINISHED: 'Finished',
        CANCELED: 'Canceled',
      }
    },

    stockReservationStatusLabel() {
      return {
        Active: this.$t('Ativo'),
        Finished: this.$t('Finalizado'),
        Canceled: this.$t('Cancelado'),
      }
    },

    stockInventoryStatusLabel() {
      return {
        [this.stockInventoryStatusEnum.IN_PROGRESS]: this.$t('InProgress'),
        [this.stockInventoryStatusEnum.INVOICE_PENDING]: this.$t(
          'STOCK_INVENTORY.STATUS.InvoicePending'
        ),
        [this.stockInventoryStatusEnum.COMPLETED_PENDING]: this.$t(
          'STOCK_INVENTORY.STATUS.CompletedPending'
        ),
        [this.stockInventoryStatusEnum.COMPLETED]: this.$t('Completed'),
        [this.stockInventoryStatusEnum.Canceled]: this.$t('Canceled'),
      }
    },

    stockMovementOriginLabel() {
      return {
        Manual: this.$t('Manual'),
        Inversion: this.$t('Inversão de estoque'),
        BarrelConsumption: this.$t('Consumo de chope'),
        PurchaseOrder: this.$t('Pedido de compra'),
        Sale: this.$t('Venda'),
        SaleReclaim: this.$t('Retorno venda'),
        SaleItemReturn: this.$t('Devolução consignado'),
        Inventory: this.$t('Inventário'),
        Invoice: this.$t('Nota fiscal'),
      }
    },
    stockMovementTypeLabel() {
      return {
        Input: this.$t('Entrada'),
        Output: this.$t('Saída'),
      }
    },
  },

  methods: {
    stockReservationStatusOptions() {
      return [
        { value: 'Active', label: this.$t('Ativo'), classStyle: 'success' },
        { value: 'Finished', label: this.$t('Finalizado'), classStyle: 'warning' },
        { value: 'Canceled', label: this.$t('Cancelado'), classStyle: 'danger' },
      ]
    },

    stockInventoryStatusOptions() {
      return [
        { value: 'InProgress', label: this.$t('InProgress'), classStyle: 'secondary' },
        {
          value: 'InvoicePending',
          label: this.$t('STOCK_INVENTORY.STATUS.InvoicePending'),
          classStyle: 'warning',
        },
        {
          value: 'CompletedPending',
          label: this.$t('STOCK_INVENTORY.STATUS.CompletedPending'),
          classStyle: 'warning',
        },
        { value: 'Completed', label: this.$t('Completed'), classStyle: 'success' },
        { value: 'Canceled', label: this.$t('Canceled'), classStyle: 'danger' },
      ]
    },

    stockCountingStatusOptions() {
      return [
        {
          value: this.stockCountingStatusEnum.IN_PROGRESS,
          label: this.$t('Em andamento'),
          classStyle: 'secondary',
        },
        {
          value: this.stockCountingStatusEnum.COMPLETED,
          label: this.$t('Finalizado'),
          classStyle: 'success',
        },
        {
          value: this.stockCountingStatusEnum.CANCELED,
          label: this.$t('Cancelado'),
          classStyle: 'danger',
        },
      ]
    },

    stockCountingDayOfWeekOptions() {
      return [
        { value: this.stockCountingDayOfWeekEnum.SUNDAY, label: this.$t('Domingo') },
        { value: this.stockCountingDayOfWeekEnum.MONDAY, label: this.$t('Segunda-feira') },
        { value: this.stockCountingDayOfWeekEnum.TUESDAY, label: this.$t('Terça-feira') },
        { value: this.stockCountingDayOfWeekEnum.WEDNESDAY, label: this.$t('Quarta-feira') },
        { value: this.stockCountingDayOfWeekEnum.THURSDAY, label: this.$t('Quinta-feira') },
        { value: this.stockCountingDayOfWeekEnum.FRIDAY, label: this.$t('Sexta-feira') },
        { value: this.stockCountingDayOfWeekEnum.SATURDAY, label: this.$t('Sábado') },
      ]
    },
  },
}

export default stockDomain
